import {
  Box,
  Button,
  Checkbox,
  Grid,
  Group,
  LoadingOverlay,
  TextInput,
  Textarea,
} from "@mantine/core";
import { hasLength, useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconWindow } from "@tabler/icons-react";
import { repositoryMdm } from "../../../../_base/_const/_constVar";
import { MessageResponse } from "../../../../model/MessageResponse";
import { TblDMTaxCode } from "../../../../model/TblDMTaxCode";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { useEffect } from "react";
import { handleKeyDown } from "../../../../_base/helper/FunctionHelper";
import { sky_blue } from "../../../../const/variables";

const CreateDataView = ({ onClose }: CreateDataViewProps) => {
  const entity = {
    id: "0",
    code: null,
    name: null,
    note: null,
    active: false,
    value: 0,
    createBy: null,
    createDate: null,
    lastUpdateBy: null,
    lastUpdateDate: null,
  };

  const [visible, { toggle, close, open }] = useDisclosure(false);

  const form = useForm<TblDMTaxCode>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },

    validate: {
      name: (value: string | null) => {
        if (!value) {
          return "Vui lòng nhập tên biểu mẫu thuế!";
        }
        return hasLength(
          { max: 100 },
          "Tên phải nhỏ hơn 100 kí tự!"
        )(value as string);
      },
      code: (value: string | null) => {
        if (!value) {
          return "Vui lòng nhập mã biểu mẫu thuế!";
        }
        return hasLength(
          { max: 100 },
          "Mã phải nhỏ hơn 100 kí tự!"
        )(value as string);
      },

      note: (value: string | null) => {
        if (value)
          return hasLength(
            { max: 250 },
            "Ghi chú phải nhỏ hơn 250 kí tự!"
          )(value as string);
      },
    },
  });

  const callApiGetData = async () => {
    open();
    const callApi = await repositoryMdm.get<MessageResponse<TblDMTaxCode>>(
      "/api/v1/TblDmTaxCode/create"
    );
    if (callApi?.success) {
      const dataApi = callApi?.data;
      if (dataApi !== null) {
        form.setValues({ ...dataApi, active: false });
        form.resetDirty(dataApi);
      }
      close();
    } else {
      NotificationExtension.Fails("Bạn không có quyền tạo!!!");
      modals.closeAll();
    }
  };

  const handleCreateTblDMTaxCode = async (dataSubmit: TblDMTaxCode) => {
    open();
    const dataApi = await repositoryMdm.post<MessageResponse<TblDMTaxCode>>(
      "/api/v1/TblDMTaxCode/create",
      dataSubmit
    );
    if (dataApi?.success) {
      onClose((prev: any) => !prev);
      modals.closeAll();
      NotificationExtension.Success("Thêm thành công !");
    }
    close();
  };

  useEffect(() => {
    callApiGetData();
  }, []);

  return (
    <>
      <Box
        component="form"
        mx="auto"
        w={{ base: "200px", md: "240px", lg: "320px" }}
        onSubmit={form.onSubmit((e: TblDMTaxCode) => {
          handleCreateTblDMTaxCode(e);
        })}
        style={{ position: "relative" }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />

        <Grid mt={10}>
          <Grid.Col span={6}>
            <TextInput
              label={"Mã biểu mẫu thuế"}
              placeholder={"Nhập mã biểu mẫu thuế"}
              type="text"
              withAsterisk
              onKeyDown={handleKeyDown}
              {...form.getInputProps("code")}
            />
          </Grid.Col>
          <Grid.Col span={6}>
            <TextInput
              label={"Tên biểu mẫu thuế"}
              placeholder={"Nhập tên biểu mẫu thuế"}
              type="text"
              withAsterisk
              {...form.getInputProps("name")}
            />
          </Grid.Col>
        </Grid>

        <Grid align="center">
          <Grid.Col span={12}>
            <TextInput
              label={"Giá trị"}
              placeholder={"Nhập giá trị"}
              type="number"
              {...form.getInputProps("value")}
            />
          </Grid.Col>
        </Grid>

        <Grid align="center">
          <Grid.Col span={12}>
            <Textarea
              label={"Ghi chú"}
              placeholder="Nhập ghi chú"
              {...form.getInputProps("note")}
            />
          </Grid.Col>
          <Grid.Col span={12}>
            <Checkbox label={"Sử dụng"} {...form.getInputProps("active")} />
          </Grid.Col>
        </Grid>

        <Group
          justify="end"
          mt="xs"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="button"
            color="gray"
            loading={visible}
            onClick={() => {
              modals.closeAll();
            }}
            leftSection={!visible ? <IconWindow size={18} /> : undefined}
          >
            Đóng
          </Button>
          <Button
            type="submit"
            color={sky_blue.base}
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
          >
            Lưu
          </Button>
          <></>
        </Group>
      </Box>
    </>
  );
};

export default CreateDataView;

type CreateDataViewProps = {
  onClose: any;
};
